import * as React from "react";
import { useNavigate } from "react-router";
import { CornerUpLeft } from "lucide-react";

interface Props {
  breadcrumbs: Array<{ label: string; params: Record<string, string> }>;
}

export const SharepointParentDir: React.FC<Props> = ({ breadcrumbs }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    // Navigate to the second-to-last breadcrumb (parent level)
    if (breadcrumbs.length >= 2) {
      const parentBreadcrumb = breadcrumbs[breadcrumbs.length - 2];
      const queryParams = new URLSearchParams(parentBreadcrumb.params).toString();
      navigate(`/sharepoint${queryParams ? `?${queryParams}` : ""}`);
    } else {
      // Fallback to menu
      navigate("/sharepoint");
    }
  };

  return (
    <div className="flex cursor-pointer items-center p-4 py-6 hover:bg-gray-100" onClick={handleNavigation}>
      <CornerUpLeft className="mr-2 h-5 w-5 text-gray-500" />
      <span className="font-medium text-gray-500">...</span>
    </div>
  );
};
